// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"296":"9a85b5e70a39c188","1349":"be650ab051e72122","2097":"bb91dda6be189186","7015":"baecae68e34a1846"}[chunkId] + ".js";
};